// import DemoLoginForm from '../../components/demo-login-form';
import Welcome from '../../components/welcome';


export default function HomePage() {

    return <Welcome />
}
